class AuthError extends Error {
  /**
   * @param {string} [message]
   */
  constructor(message = 'Not logged in') {
    super(message);
    this.name = 'AuthError';
  }
}

export default AuthError;
